(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["behind-scene"] && !Shopify.designMode) return;
  try {
    
  function initScienceCarousel() {
    const containers = document.querySelectorAll('[class*="main-carousel-"]');
    
    containers.forEach(container => {
      const sectionId = container.className.split('main-carousel-')[1].split(' ')[0];
      const flkty = new Flickity(container, {
        cellAlign: 'left',
        wrapAround: true,
        prevNextButtons: false,
        pageDots: true,
        percentPosition: true,
        setGallerySize: true,
        dragThreshold: 18,          // 10–25 is good; 18 is a sweet spot for most sites
        touchVerticalScroll: false,          // ← Start here (10–25 range). Higher = more vertical-scroll friendly
        // accessibility: false,    // Uncomment if keyboard focus jumps annoy you on mobile
      });

      // ──────────────────────────────────────────────
      //  Place for Option #4 style code (variation)
      // ──────────────────────────────────────────────
      // This makes Flickity less "greedy" after vertical attempts
      let ignoreDragFor = 0;

      flkty.on('pointerDown', () => {
        ignoreDragFor = Date.now() + 400;  // ignore drags for ~400ms after touch start
      });

      flkty.on('dragStart', () => {
        if (Date.now() < ignoreDragFor) {
          // Short vertical drag attempt → cancel it early
          flkty.cancelDrag?.();  // not official, but sometimes helps
          flkty.element.style.pointerEvents = 'none';  // let touch "pass through" briefly
          setTimeout(() => {
            flkty.element.style.pointerEvents = '';
          }, 180);
        }
      });

      // ──────────────────────────────────────────────
      // Your existing nav buttons
      document.getElementById(`prevBtn-${sectionId}`)?.addEventListener('click', () => flkty.previous());
      document.getElementById(`nextBtn-${sectionId}`)?.addEventListener('click', () => flkty.next());

      // ──────────────────────────────────────────────
      // Geek toggle + resize
      container.querySelectorAll('.js-geek-toggle').forEach(toggle => {

      // Inside your .js-geek-toggle change listener
      toggle.addEventListener('change', function() {
        const card = this.closest('.ingredient-card');
        const desc = card.querySelector('.js-description');
        const isExpanded = this.checked;

        if (isExpanded) {
          desc.classList.add('is-expanded');
        } else {
          desc.classList.remove('is-expanded');
        }

        // ──────────────────────────────────────────────────────────────
        //   Optional: Disable dragging while geek mode is ON
        // ──────────────────────────────────────────────────────────────
        flkty.options.draggable = !isExpanded;   // ← no horizontal drag when expanded
        // or: flkty.options.dragThreshold = isExpanded ? 9999 : 18;

        setTimeout(() => {
          flkty.resize();
          flkty.reposition();
        }, 100);  // give browser time to reflow
      });

        /*
        toggle.addEventListener('change', function() {
          const card = this.closest('.ingredient-card');
          const desc = card.querySelector('.js-description');
          const isExpanded = this.checked;

          if (isExpanded) {
            desc.classList.add('is-expanded');
          } else {
            desc.classList.remove('is-expanded');
          }

          // Optional stronger fix: disable dragging while geek mode is ON (long text)
          // flkty.options.draggable = !isExpanded;

          setTimeout(() => {
            flkty.resize();
            flkty.reposition();
          }, 80);  // slightly longer delay helps iOS
        });*/

      });
    });
  }

  document.addEventListener('DOMContentLoaded', initScienceCarousel);
  document.addEventListener('shopify:section:load', initScienceCarousel);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.getElementById('shopify-section-header');
      this.headerBounds = {};
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
